import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2681afa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../walletHistory/style.less?vue&type=style&index=0&lang=less&"
import style1 from "./index.vue?vue&type=style&index=1&id=d2681afa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2681afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2681afa')) {
      api.createRecord('d2681afa', component.options)
    } else {
      api.reload('d2681afa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d2681afa&scoped=true&", function () {
      api.rerender('d2681afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/coin1/index.vue"
export default component.exports